import * as React from 'react';
import { IAlignedWord } from '../api';

interface IProps {
    onClick: (word: IAlignedWord) => void,
    word: IAlignedWord,
    currentTime: number | null,
    text: string,
    index: number,
}

export class Word extends React.PureComponent<IProps> {

    public render() {
        const {text} = this.props;

        return (<span
            className={
                'word' +
                (this.hasPlayed() ? ' played' : '') +
                (this.isPlaying() ? ' playing' : '') +
                (this.isBad() ? ' bad' : '')
            }
            onClickCapture={this.onClick}>
                {text}
            </span>);
    }

    private onClick = () => {
        this.props.onClick(this.props.word);
    }

    private hasPlayed() {
        const {
            word,
            currentTime,
        } = this.props;

        if (currentTime === null) {
            return false;
        }

        return (word.start + word.duration) <= currentTime;
    }
  
    private isPlaying() {
        const {
            word,
            currentTime,
        } = this.props;

        if (currentTime === null) {
            return false;
        }

        return word.start <= currentTime &&
            (word.start + word.duration) > currentTime;
      }

    private isBad() {
        const { word } = this.props;
        return word.confidence < 0.5;
    }

}

export default Word;



// WEBPACK FOOTER //
// ./src/components/Word.tsx